"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This utility is used for locales.
 */
var LocaleUtility = /** @class */ (function () {
    function LocaleUtility() {
    }
    /**
     * Converts a locale to country and language.
     *
     * @param locale Locale. Example: en-GB.
     * @returns Country and language.
     */
    LocaleUtility.getCountryAndLanguage = function (locale) {
        var list = locale.split('-');
        if (list.length > 1 && list[0].length === 2 && list[1].length === 2) {
            return {
                country: list[1].toLowerCase(),
                language: list[0].toLowerCase()
            };
        }
        return {
            country: null,
            language: null
        };
    };
    return LocaleUtility;
}());
exports.default = LocaleUtility;
//# sourceMappingURL=LocaleUtility.js.map